<!-- 账户余额-->
<template>
  <div class="user-balance" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="我的账户" class="user_balance_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #4374FF; color:#FFFFFF;'"></van-nav-bar>

    <div class="header-b">
      <div class="header-bg"> </div>
      <div class="header-cn">
        <div class="header-cn-block">
          <p class="tips">当前余额(元)</p>
          <h3 class="price">{{balance.total | numToCash}}</h3>
          <p class="h-btn click"><span @click="goPage({name:'on-line-recharge',qurey:{}})">在线充值</span></p>
        </div>
      </div>
    </div>

    <!-- 底部入口 -->

    <div class="foot-block">

      <div class="foot-item" @click="goPage({name:'balance-log-list',qurey:{}})" >
        <div class="foot-img">
          <img src="../../assets/bj_user/zh_icon.png" alt="">
        </div>
        <p class="foot-title ">账户明细</p>
      </div>
      <div class="foot-item"  @click="goPage({name:'consume-log-list',qurey:{}})" >
        <div class="foot-img">
          <img src="../../assets/bj_user/xf_icon.png" alt="">
        </div>
        <p class="foot-title ">消费明细</p>
      </div>

    </div>

  </div>
</template>

<script type="text/babel"> 
export default {
  name: "UserBalance",
  components: {  },
  props: {},
  data() {
    return { 
      balance: {
        total: 0, //余额
        true_amt: 0, //充值余额
        gift_amt: 0,  //赠送余额
      },
      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    this.$toast.loading(); 
    this.getInit();
  },
  methods: {
    // 初始化数据
    getInit() {
      let _this = this;
      _this.$post("/api/balance").then((res) => {
        console.log(res.data, "底部table");
        if (res.data && res.data.code == 0) {
          this.balance = res.data.data;
          this.$toast.clear();
        }
      });
    },
  // 条路有
    goPage(even) {
      let _this = this;
      if (!this.isLogin()) return false;
      // console.log(even) 
        this.$router.push(even); 
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.user_balance_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.user-balance {
  height: 100%;
  width: 100%;
  padding: 0 0 50px 0;
  background-color: #f7f7f7;
  .header-b {
    height: 208px;
    width: 100%;
    // background-color: darkcyan;
    position: relative;

    .header-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 130px;
      background: #4374ff;
      border-bottom-left-radius: 30%;
      border-bottom-right-radius: 30%;
    }

    .header-cn {
      position: absolute;
      top: 40px;
      left: 0;
      z-index: 1;
      width: 100%;
      //   background-color: tan;
      //   border: #454f63 solid 1px;
      padding: 20px 20px 0 20px;

      .header-cn-block {
        height: 146px;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
      }
      .tips {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
      }
      .price {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }

      .h-btn {
        margin-top: 20px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2897ff;
        span {
          padding: 5px 10px;

          background: rgba(255, 255, 255, 0.6);
          border: 1px solid #2998ff;
          border-radius: 14px;
        }
      }
    }
  }
  //
  .foot-block {
    width: 100%;
    height: 135px;
    // background-color: green;
    padding: 15px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .foot-item {
      width: 165px;
      height: 100%;
      background: #ffffff;
      border-radius: 10px;
      padding: 20px 15px;

      .foot-img {
        width: 100%;
        height: 28px;
        img {
          display: block;
          height: 100%;
          width: 28px;
        }
      }
      .foot-title {
        margin-top: 18px;
        text-align: left;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
